<template>
  <div
    class="ui-space-table__spoiler"
    :style="{
      'grid-template-columns': gridLayout,
      'grid-template-rows': height
    }"
  >
    <Row
      class="-spoiler- -pointer-"
      :nav-titles="navTitles"
      height="43px"
      @click="changeSpoiler()"
    >
      <Cell class="-full-border-">
        {{ title }}
        <Icon
          class="ui-space-table__icon -arrow-"
          icon="arrow-down-thick"
          :class="{ '-rotate-': !localHidden }"
        />
      </Cell>
      <Cell class="-full-border-"> {{ fillable }} % </Cell>
      <Cell class="-full-border-">
        {{ revenueToOne }} ₽
        <div
          class="ui-space-table__upper-text"
          :class="{
            '-negative-': revenueGrowth <= 0,
            '-positive-': revenueGrowth > 0
          }"
        >
          <Icon
            class="ui-space-table__icon -arrow-"
            icon="arrow-down-thick"
            :class="{ '-rotate-': revenueGrowth > 0 }"
          />{{ Math.abs(revenueGrowth) }} %
        </div>
      </Cell>
      <Cell class="-full-border-">
        {{ profitToOne }} ₽
        <div
          class="ui-space-table__upper-text"
          :class="{
            '-negative-': profitGrowth <= 0,
            '-positive-': profitGrowth > 0
          }"
        >
          <Icon
            class="ui-space-table__icon -arrow-"
            icon="arrow-down-thick"
            :class="{ '-rotate-': profitGrowth > 0 }"
          />
          {{ Math.abs(profitGrowth) }} %
        </div>
      </Cell>
    </Row>
    <div
      class="ui-space-table__spoiler-opener"
      :class="{ '-hidden-': localHidden }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import Cell from './Cell';
import Row from '../../components/Table/Row';

export default {
  components: { Cell, Row },
  props: {
    title: {
      type: String
    },
    fillable: {},
    revenueToOne: {},
    profitToOne: {},
    revenueGrowth: {},
    profitGrowth: {},
    defaultWidth: {
      type: String,
      default: '60px'
    },
    navTitles: {},
    height: {
      type: String,
      default: '32px'
    },
    hidden: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localHidden: this.hidden
    };
  },
  computed: {
    gridLayout() {
      const result = [];
      this.navTitles.forEach(prop => {
        if (prop) {
          result.push(prop.width || this.defaultWidth);
        }
      });
      return result.join(' ');
    }
  },
  methods: {
    changeSpoiler() {
      this.localHidden = !this.localHidden;

      if (this.localHidden) {
        this.$emit('closed');
      } else {
        this.$emit('opened');
      }
    }
  }
};
</script>
